import { SET_ORDER_UPDATE_VALUE } from './actionTypes';

import PickupOrder from '../../models/PickupOrder';
import { baseUrl } from '../../api/baseUrl';
import { receiveError } from './notificationAction';

function setOrder(hash: string) {
  return {
    type: SET_ORDER_UPDATE_VALUE,
    data: hash
  }
}

function setOrderAction(hash: string) {

  return (dispatch: any) => {

    dispatch(setOrder(hash));
  };
}

function setOrderConnect() {

  return (dispatch: any) => {

    const queue = new EventSource(baseUrl + `orders`, {
        withCredentials: true
    });



    queue.onmessage = (event) => {

      const parsedData = JSON.parse(event.data);
      if(parsedData) {
        dispatch(setOrderAction(parsedData));
      }

    }

    queue.onerror = (error: any) => {

      if(error.type === 'error') {

        dispatch(receiveError(error));

      }

   }
  };
}

export {
  setOrderAction,
  setOrderConnect
};